import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/69d65f17a749570014e75cb4/eventgame/src/app/not-found.tsx");
